import React, { useState } from 'react'
import FormNotification from '../../../../components/SelfService/FormNotification.jsx'
import InputGroup from '../../../../components/EmailSubscriptionCenter/SignIn/InputGroup.jsx'
import {
  screens,
  makeMFAnswerRequest,
  accessStorage,
  errorMessage,
  OTP_RESPONSE_CODES,
} from './institutionalServiceHelper.js'

export default function InstitutionalMFAnswer({
  screenChangeHandler,
  mfaAnswerData,
  setShowLoader,
  onSuccessFullLogin,
  onCancleClick,
}) {
  const [otp, setOtp] = useState('')
  const [formErrorMessage, setFormErrorMessage] = useState('')
  const [formValidation, setFormValidation] = useState({
    'login-one-time-passcode': {
      error: false,
      errorMessage: '',
    },
  })

  const onChangeOneTimePasscodeInput = (event) => {
    const _formValidation = { ...formValidation }
    _formValidation['login-one-time-passcode'].error = false
    setFormValidation(_formValidation)
    setOtp(event.target.value)
  }

  const onNextClicked = async () => {
    if (!otp) {
      return
    }
    setShowLoader(true)
    try {
      const data = await makeMFAnswerRequest({ otp })
      if (data?.error) {
        if (data?.error?.details) {
          handleError(data.error.details.code)
        } else {
          handleError(data?.error?.code)
        }
      } else {
        if (
          data?.value?.userId ||
          (data?.value?.userInfo &&
            Object.keys(data?.value?.userInfo)?.length > 1)
        ) {
          accessStorage.setUserInfo({
            ...data?.value?.userInfo,
            userId: data?.value?.userId,
          })
        }
        onSuccessFullLogin()
      }
    } catch (error) {
      setFormErrorMessage(errorMessage.defaultError)
    }
    setShowLoader(false)
  }

  const handleError = (errorCode) => {
    const _formValidation = { ...formValidation }
    switch (errorCode) {
      case OTP_RESPONSE_CODES.CREDENTIALS_NOT_ACCEPTED:
      case OTP_RESPONSE_CODES.OTP_EXPIRED:
      case OTP_RESPONSE_CODES.FYP_INVALID_CODE:
      case OTP_RESPONSE_CODES.SUBSCRIBE_USER_INVALID_OTP:
      case OTP_RESPONSE_CODES.SUBSCRIBE_USER_INVALID_OTP_2:
        _formValidation['login-one-time-passcode'].error = true
        _formValidation['login-one-time-passcode'].errorMessage =
          'The passcode you entered is incorrect or has expired. Please check the code you received and try again.'
        setFormValidation(_formValidation)
        break
      case OTP_RESPONSE_CODES.SSO_LOCKED:
      case OTP_RESPONSE_CODES.BLOCKED_MFA:
      case OTP_RESPONSE_CODES.LOCKED_MFA:
        setFormErrorMessage(errorMessage.otpFailedAttempts)
        break
      default:
        setFormErrorMessage(errorMessage.defaultError)
    }
  }

  const onDidntReceiveCodeClick = () => {
    screenChangeHandler(screens.MFA_SCREEN)
  }

  return (
    <div className="u-sizeConstrained" data-analytics-login-step="Enter OTP">
      <div className="Grid">
        <div className="u-sizeFull u-lg-size5of12 u-lg-after1of12 u-marginBottom6gu u-lg-marginBottom0 Content">
          {formErrorMessage && (
            <FormNotification content={formErrorMessage} isHtml={true} />
          )}
          <div>
            <h2 className="u-marginTop0 u-marginBottom1gu">PASSCODE SENT</h2>
            <p className="u-marginBottom2gu">
              It may take up to 60 seconds for your passcode to arrive. Enter
              the 6-digit passcode we sent to XXX.XXX.
              {mfaAnswerData?.route?.slice(-4)}.
            </p>
          </div>
          <p>Your code:</p>
          <ul className="List u-marginBottom8gu">
            <li className="List-item u-textPrimary u-marginBottom0 u-padding0">
              Expires after 30 minutes
            </li>
            <li className="List-item u-textPrimary u-padding0">
              Does not replace your current password
            </li>
          </ul>
          <InputGroup
            handleInputChange={onChangeOneTimePasscodeInput}
            formValidation={formValidation}
            fieldName="login-one-time-passcode"
            fieldId="login-one-time-passcode"
            placeholder="Enter the passcode you received"
            label="One-time passcode"
            compact={false}
            defaultValue={otp}
          />

          <div className="u-flex u-marginBottom3gu">
            <div className="u-flex">
              <button
                onClick={onNextClicked}
                disabled={!otp}
                className="Button Button--primary Button--block u-marginRight5gu u-textSecondary u-paddingHoriz8gu u-textNoTransform"
                data-analytics="login-otp-continue"
              >
                Next
              </button>
              <button
                onClick={onCancleClick}
                className="Button Button--tertiary Button--block u-paddingHoriz8gu u-textNoTransform"
                data-analytics="login-otp-cancel"
              >
                Cancel
              </button>
            </div>
          </div>
          <button
            onClick={onDidntReceiveCodeClick}
            className="Link u-block"
            data-analytics="login-otp-no-code"
          >
            Didn&apos;t receive your code?
          </button>
        </div>
      </div>
    </div>
  )
}
